"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPaymentConfigurationStatus = exports.PaymentPageEventKeys = void 0;
var PaymentPageEventKeys;
(function (PaymentPageEventKeys) {
    PaymentPageEventKeys["PAYMENT_SERVICES_FETCHED"] = "payment-services-fetched";
    PaymentPageEventKeys["PAYMENT_SERVICE_UPDATED"] = "mfe-payment-page/payment-service-updated";
    PaymentPageEventKeys["HTTP_ERROR"] = "mfe-payment-page/http-error";
})(PaymentPageEventKeys || (exports.PaymentPageEventKeys = PaymentPageEventKeys = {}));
var EPaymentConfigurationStatus;
(function (EPaymentConfigurationStatus) {
    EPaymentConfigurationStatus["APPROVED"] = "approved";
    EPaymentConfigurationStatus["PENDING_APPROVAL"] = "pending_approval";
    EPaymentConfigurationStatus["DENIED"] = "denied";
})(EPaymentConfigurationStatus || (exports.EPaymentConfigurationStatus = EPaymentConfigurationStatus = {}));
//# sourceMappingURL=models.js.map